import * as React from "react";
import styled, { css, keyframes } from "styled-components";
import chroma from "chroma-js";
const DEFAULT_BAR = {
  animated: false,
  bsStyle: "info",
  label: void 0,
  striped: false,
  value: 0
};
const boxShadow = (meta) => css`
  box-shadow: ${meta} ${({ theme }) => chroma(theme.colors.brand.secondary).alpha(0.1).css()};
`;
const animatedStripes = keyframes`
  from {
    background-position: 40px 0;
  }

  to {
    background-position: 0 0;
  }
`;
const progressBarVariants = css(({ $bsStyle, theme }) => {
  if (!$bsStyle) {
    return void 0;
  }
  return css`
    background-color: ${theme.colors.variant[$bsStyle]};
    color: ${theme.utils.readableColor(theme.colors.variant[$bsStyle])};
  `;
});
const ProgressWrap = styled.div(
  ({ theme }) => css`
    height: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    background-color: ${theme.colors.gray[90]};
    border-radius: 4px;
    ${boxShadow("inset 0 1px 2px")}
    display: flex;
    align-items: center;
  `
);
const Bar = styled.div(({ $animated, $striped, theme, value }) => {
  const defaultStripColor = chroma(theme.colors.global.contentBackground).alpha(0.25).css();
  return css`
    height: 100%;
    font-size: ${theme.fonts.size.small};
    text-align: center;
    ${boxShadow("inset 0 -1px 0")}
    transition: width 500ms ease-in-out;
    width: ${value}%;
    max-width: 100%;
    text-shadow:
      0 1px 2px ${chroma(theme.colors.gray[10]).alpha(0.4).css()},
      2px -1px 3px ${chroma(theme.colors.gray[100]).alpha(0.5).css()};
    ${($animated || $striped) && css`
      background-image: linear-gradient(
        45deg,
        ${defaultStripColor} 25%,
        transparent 25%,
        transparent 50%,
        ${defaultStripColor} 50%,
        ${defaultStripColor} 75%,
        transparent 75%,
        transparent
      );
      background-size: 40px 40px;
    `}
    ${$animated && css`
      animation: ${animatedStripes} 2s linear infinite;
    `}
    ${progressBarVariants}
  `;
});
const ProgressBar = ({ bars = [DEFAULT_BAR], className = void 0 }) => /* @__PURE__ */ React.createElement(ProgressWrap, { className }, bars.map((bar, index) => {
  const { label, animated, bsStyle, striped, value } = { ...DEFAULT_BAR, ...bar };
  return /* @__PURE__ */ React.createElement(
    Bar,
    {
      role: "progressbar",
      "aria-valuenow": value,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuetext": label,
      key: `bar-${index}`,
      $animated: animated,
      $bsStyle: bsStyle,
      $striped: striped,
      value
    },
    label
  );
}));
export default ProgressBar;
export { Bar };
